import { render, staticRenderFns } from "./system-emails-layout.vue?vue&type=template&id=b9f2cdf8"
import script from "./system-emails-layout.vue?vue&type=script&lang=js"
export * from "./system-emails-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports